<template>
  <van-action-sheet v-model:show="show" :title="$t('message.dialogtitle')" v-bind="$attrs" :class="['consult-dialog', `title-${$i18n.locale}`]">
    <van-tabs v-model:active="tab">
      <van-tab name="order" :title="$t('message.order')">
        <List :get-data="async (pageNow) => {
      const res = await getOrderList(pageNow);
      return {
        listData: res.data?.records || [],
        hasMore: pageNow < res.data?.pageCount,
      };
    }
    ">
          <template #default="{ goods, orderId }">
            <OrderItem :order-id="orderId" :goods="goods" @send="(data) => $emit('send', { data, type: tab })" />
          </template>
        </List>
      </van-tab>
      <van-tab name="viewed" :title="$t('message.viewed')">
        <List :get-data="async (pageNow) => {
      const res = await getRecentlyViewedGoodsList(pageNow);
      return {
        listData: res.data?.records || [],
        hasMore: res.data?.records
          ? pageNow < res.data?.pageCount
          : !!res.data?.records,
      };
    }
    ">
          <template #default="{ goods }">
            <GoodsItem :goods="goods" @send="(data) => $emit('send', { data, type: tab })" />
          </template>
        </List>
      </van-tab>
      <van-tab name="favorites" :title="$t('message.favorites')">
        <List :get-data="async (pageNow) => {
      const res = await getFavoriteGoodsList(pageNow);
      return {
        listData: res.data?.records || [],
        hasMore: res.data?.records
          ? pageNow < res.data?.pageCount
          : !!res.data?.records,
      };
    }
    ">
          <template #default="{ goods }">
            <GoodsItem :goods="goods" @send="(data) => $emit('send', { data, type: tab })" />
          </template>
        </List>
      </van-tab>
      <van-tab name="cart" :title="$t('message.cart')">
        <List :get-data="async (pageNow) => {
      const res = await getCartInfo(pageNow);
      return {
        listData: res.data?.shoppingCartModelVOList?.find(i=>i.modelType===0)?.cartGoods || [],
        hasMore: false
      };
    }
    ">
          <template #default="{ goods }">
            <GoodsItem :goods="goods" @send="(data) => $emit('send', { data, type: tab })" />
          </template>
        </List>
      </van-tab>
    </van-tabs>
    <div v-if="props.showTip" class="bottom-tip" @click="$emit('update:show', false);">{{ $t('message.contactServiceText') }} <span>{{ $t('message.contactService') }}</span></div>
  </van-action-sheet>
</template>

<script setup lang="ts">
import {
  getCartInfo,
  getFavoriteGoodsList,
  getOrderList,
  getRecentlyViewedGoodsList,
} from "@/api/order";
import List from "./list.vue";
import GoodsItem from "./goods-item.vue";
import OrderItem from "./order-item.vue";

type TabName = "order" | "favorite" | "viewed" | "cart" | (string & {})

defineEmits<{
  send: [any];
  'update:show': [boolean];
}>();

const show = defineModel<boolean>("show", { default: true });
const tab = defineModel<TabName>("tab", { default: "order" });

const props = defineProps({
  /**
   * 商品数据
   */
  showTip: {
    type: Boolean,
    default:false
  },
})
</script>

<style lang="scss" scoped>
.bottom-tip{
  position: fixed;
  height: 40px;
  padding: 4px 0;
  bottom: env(safe-area-inset-bottom);
  left: 0;
  right: 0;
  text-align: center;
  background-color: #f6f6f6;

  span{
    text-decoration: underline;
    color: #2440b3;
  }
}
</style>

<style lang="scss">
.consult-dialog {
  background-color: #f6f6f6;
  height: 60vh;
  max-height: 60vh;

  .van-tabs {
    position: relative;
  }

  .van-tabs__wrap {
    background-color: #f6f6f6;
    position: sticky;
    top: 0;
    z-index: 2002;
  }

  .van-tabs__nav {
    background-color: transparent;
  }

  .van-list {
    padding: 0 13px;
  }

  .van-cell {
    padding: 15px 12px 10px;
  }

  .van-cell:not(nth-last-of-type) {
    margin-bottom: 10px;
  }
  .van-action-sheet__header {
    padding-right: 48px;
    padding-left: 12px;
  }
  &.title-de, &.title-es, &.title-is, &.title-mt, &.title-bg, &.title-hu {
    .van-action-sheet__header {
      font-size: 13px;
    }
  }
  &.title-fr, &.title-ru {
    .van-action-sheet__header {
      font-size: 11px;
    }
  }
  &.title-ro {
    .van-action-sheet__header {
      font-size: 12px;
    }
  }
}
</style>
